export default {
 pageTitle: 'About Us',
 heroSlogan: 'Focused on cross-border services, integrating law, finance and business to escort enterprises going global',
 aboutUsTitle: 'About Us',
 paragraph1: 'LEVIY GLOBAL was founded in Hangzhou in 2005 and established its headquarters in Hangzhou. It currently has branches in major cities such as Hong Kong and Shenzhen, with business covering over 50 countries and regions globally.',
 paragraph2: 'Specializing in providing one-stop offshore services including company registration and secretarial services, foreign financial services, international tax planning, overseas structure setup, overseas identity planning, and global intellectual property services.',
 paragraph3: 'With over 20 years of experience in offshore services, LEVIY GLOBAL has grown into a leader in one-stop offshore services and solutions, serving over 100 enterprises and earning a good reputation in the industry.',
 paragraph4: 'LEVIY GLOBAL has successfully built a wide global legal service network, providing civil, commercial, and criminal legal services related to clients\' business and personal needs through lawyers in various countries.',
 stat1Label: 'Founded in',
 stat2Label: 'Countries Covered',
 stat3Label: 'Enterprises Served',
 stat4Label: 'Industry Experience',
 milestoneTitle: 'Development History',
 milestoneSubtitle: 'Witness our growth and development',
 milestone1: 'Company founded in Hangzhou',
 milestone2: 'Business expanded to over 20 countries globally',
 milestone3: 'Branches in Hong Kong and Shenzhen established',
 milestone4: 'Service network covering 50+ countries and regions',
 milestone5: 'Served over 100 enterprises',
 valuesTitle: 'Core Values',
 valuesSubtitle: 'Our Service Philosophy',
 value1Title: 'Professionalism',
 value1Desc: 'Over 20 years of industry experience, focusing on the cross-border service field',
 value2Title: 'Integrity',
 value2Desc: 'Based on integrity, providing reliable services to clients',
 value3Title: 'Innovation',
 value3Desc: 'Continuously innovating service models to enhance client experience',
 value4Title: 'Globalization',
 value4Desc: 'Service network covering 50+ countries and regions',
 officesTitle: 'Office Locations',
 officesSubtitle: 'Our global office network',
 office1City: 'Hangzhou Headquarters',
 office1Address: 'Room 1101, Metro Business Building, No.611 Zhongshan North Road, Gongshu District, Hangzhou, Zhejiang, China',
 office2City: 'Shenzhen Branch',
 office2Address: '3107, West Zone, Block 31, Dazhonghua International Trading Square, Fuhua Road 1, Futian District, Shenzhen, Guangdong, China',
 office3City: 'Hong Kong Branch',
 office3Address: 'Room 08, 15/F, Wida Commercial Center, Tongcha Street 1A-1L, Mongkok, Kowloon, Hong Kong',
 ctaTitle: 'Embark on Your Global Journey',
 ctaDesc: 'Choose LEVIY, a professional and reliable cross-border service partner',
 ctaButton: 'Email Consultation',
}
